var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarBonusBalance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 1.5C7.92172 1.5 4.61572 4.806 4.61572 8.8845C4.61572 12.963 7.92172 16.269 12.0002 16.269C16.0787 16.269 19.3847 12.963 19.3847 8.8845C19.3847 4.806 16.0787 1.5 12.0002 1.5ZM15.247 8.283L13.8977 9.5985L14.2165 11.4555C14.2697 11.7645 13.945 12 13.6682 11.8538L12.0002 10.977L10.3322 11.8538C10.0547 11.9993 9.73072 11.7638 9.78397 11.4555L10.1027 9.5985L8.75347 8.283C8.52922 8.064 8.65297 7.683 8.96272 7.638L10.8272 7.36725L11.6612 5.6775C11.8 5.39625 12.2005 5.39625 12.3392 5.6775L13.1732 7.36725L15.0377 7.638C15.3475 7.683 15.4712 8.06475 15.247 8.283Z",
    fill: "#FF8400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 17.3934C10.3933 17.3934 8.89555 16.9381 7.6123 16.1611V22.1026C7.6123 22.4176 7.96481 22.6051 8.22731 22.4326L11.7823 20.1001C11.9173 20.0101 12.0823 20.0101 12.2173 20.1001L15.7723 22.4326C16.0348 22.6051 16.3873 22.4176 16.3873 22.1026V16.1611C15.1041 16.9381 13.6063 17.3934 11.9998 17.3934Z",
    fill: "#FF8400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarBonusBalance);
export default __webpack_public_path__ + "static/media/sidebar-bonus-balance.0642ff9e50b7f34e0a2e9fcb837611c3.svg";
export { ForwardRef as ReactComponent };